var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"logo",staticStyle:{"cursor":"pointer"}},[_c('img',{attrs:{"src":_vm.config.logoUrl,"alt":"logo"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.config.logoText))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52a317c7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/components/SideInfo.vue
// module id = null
// module chunks = 